var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-card-body d-flex",staticStyle:{"min-height":"250px"}},[_c('div',{staticClass:"mx-auto"},[_c('vue-skeleton-loader',{attrs:{"type":"rec","width":_vm.width,"height":_vm.height,"animation":"fade"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }